import { object, string } from 'superstruct';
import { parsableInteger } from '@arc/shared/util-superstruct';
export const FILTER_OPTION_NONE = 'None';
export const FILTER_OPTION_MINE = 'Mine';
export const FilterByQuoteDto = object({
  id: parsableInteger(),
  customerId: parsableInteger(),
  number: string(),
  name: string()
});
export const FilterByProjectBoardDto = object({
  id: parsableInteger(),
  customerId: parsableInteger(),
  name: string()
});
export const FilterByUser = object({
  id: parsableInteger(),
  name: string()
});